var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutContent(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2020.9 1750.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#luminosity-noclip-11);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-4, .cls-19, .cls-21, .cls-23, .cls-36, .cls-38, .cls-40, .cls-68, .cls-73, .cls-81, .cls-91, .cls-97, .cls-109, .cls-120, .cls-125, .cls-130, .cls-131, .cls-139 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-148 {\n        filter: url(#luminosity-noclip-17);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-6, .cls-9, .cls-24, .cls-32, .cls-149, .cls-50, .cls-150, .cls-70, .cls-71, .cls-85, .cls-89, .cls-151, .cls-104, .cls-106, .cls-152, .cls-141 {\n        isolation: isolate;\n      }\n\n      .cls-6, .cls-50 {\n        opacity: .41;\n      }\n\n      .cls-153 {\n        mask: url(#mask-23);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-9 {\n        opacity: .23;\n      }\n\n      .cls-9, .cls-25 {\n        fill: #f69971;\n      }\n\n      .cls-154 {\n        mask: url(#mask-10);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-155 {\n        mask: url(#mask-26);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-12 {\n        fill: #6b17c3;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-156 {\n        filter: url(#luminosity-noclip-7);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-157 {\n        filter: url(#luminosity-noclip-13);\n      }\n\n      .cls-158 {\n        mask: url(#mask-17);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-159 {\n        mask: url(#mask-41);\n      }\n\n      .cls-17 {\n        fill: #fbfeff;\n      }\n\n      .cls-160 {\n        filter: url(#luminosity-noclip-5);\n      }\n\n      .cls-18 {\n        fill: #fca37e;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-22 {\n        fill: #0376ff;\n      }\n\n      .cls-161 {\n        mask: url(#mask-2);\n      }\n\n      .cls-162 {\n        mask: url(#mask-34);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-163 {\n        mask: url(#mask-33);\n      }\n\n      .cls-164 {\n        filter: url(#luminosity-noclip-25);\n      }\n\n      .cls-24 {\n        opacity: .73;\n      }\n\n      .cls-24, .cls-111 {\n        fill: #fff;\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-165 {\n        filter: url(#luminosity-noclip-31);\n      }\n\n      .cls-166 {\n        mask: url(#mask-13);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-167 {\n        mask: url(#mask-3);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-32, .cls-70, .cls-89 {\n        opacity: .26;\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-149 {\n        opacity: .4;\n      }\n\n      .cls-168 {\n        filter: url(#luminosity-noclip-29);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-169 {\n        mask: url(#mask-31);\n      }\n\n      .cls-170 {\n        filter: url(#luminosity-noclip-15);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-39 {\n        fill: #fcfeff;\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-171 {\n        mask: url(#mask-32);\n      }\n\n      .cls-172 {\n        mask: url(#mask-9);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-122);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-120);\n      }\n\n      .cls-173 {\n        mask: url(#mask-39);\n      }\n\n      .cls-174 {\n        mask: url(#mask-12);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-175 {\n        mask: url(#mask-5);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-54 {\n        fill: #fff728;\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-176 {\n        mask: url(#mask-36);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-177 {\n        filter: url(#luminosity-noclip-21);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-178 {\n        mask: url(#mask-35);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-61 {\n        fill: #fc0c83;\n      }\n\n      .cls-179 {\n        mask: url(#mask-40);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-180 {\n        mask: url(#mask-20);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-65 {\n        fill: #f68d60;\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-181 {\n        filter: url(#luminosity-noclip-9);\n      }\n\n      .cls-150 {\n        opacity: .18;\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-182 {\n        mask: url(#mask-38);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-183 {\n        filter: url(#luminosity-noclip-35);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-63);\n        opacity: .35;\n      }\n\n      .cls-184 {\n        mask: url(#mask-25);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-185 {\n        mask: url(#mask-8);\n      }\n\n      .cls-74 {\n        fill: #8799fd;\n      }\n\n      .cls-75 {\n        fill: #ffc33e;\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-186 {\n        filter: url(#luminosity-noclip-33);\n      }\n\n      .cls-77 {\n        fill: #057cff;\n      }\n\n      .cls-187 {\n        mask: url(#mask-4);\n      }\n\n      .cls-188 {\n        mask: url(#mask-24);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-119);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-189 {\n        mask: url(#mask-19);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-190 {\n        mask: url(#mask-15);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-84 {\n        fill: #ffbc3e;\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-42);\n        opacity: .23;\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-191 {\n        mask: url(#mask-6);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-151 {\n        opacity: .34;\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-117);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-192 {\n        mask: url(#mask-16);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-193 {\n        mask: url(#mask-18);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-104 {\n        fill: #ff9263;\n        opacity: .32;\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-194 {\n        mask: url(#mask-37);\n      }\n\n      .cls-106 {\n        fill: #d1d8ff;\n        opacity: .67;\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-152 {\n        opacity: .16;\n      }\n\n      .cls-195 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-121);\n      }\n\n      .cls-196 {\n        mask: url(#mask-1);\n      }\n\n      .cls-197 {\n        mask: url(#mask);\n      }\n\n      .cls-198 {\n        filter: url(#luminosity-noclip-23);\n      }\n\n      .cls-112 {\n        fill: #bf98ff;\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-199 {\n        mask: url(#mask-22);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-200 {\n        mask: url(#mask-29);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-119 {\n        fill: #181a5c;\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-201 {\n        mask: url(#mask-7);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-124 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-126 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-202 {\n        opacity: .16;\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-203 {\n        mask: url(#mask-30-3);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-132 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-134 {\n        fill: #f9fdff;\n      }\n\n      .cls-135 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-118);\n      }\n\n      .cls-204 {\n        mask: url(#mask-14);\n      }\n\n      .cls-205 {\n        filter: url(#luminosity-noclip-19);\n      }\n\n      .cls-137 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-206 {\n        mask: url(#mask-21);\n      }\n\n      .cls-207 {\n        mask: url(#mask-27-2);\n      }\n\n      .cls-138 {\n        fill: #ffd53e;\n      }\n\n      .cls-208 {\n        filter: url(#luminosity-noclip-27);\n      }\n\n      .cls-209 {\n        mask: url(#mask-11);\n      }\n\n      .cls-210 {\n        mask: url(#mask-28);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-140 {\n        fill: url(#linear-gradient-115);\n      }\n\n      .cls-141 {\n        fill: #adbaff;\n        opacity: .33;\n      }\n\n      .cls-211 {\n        filter: url(#luminosity-noclip-3);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-116);\n      }\n\n      .cls-143 {\n        fill: #ffcbb4;\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-75);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 1217.51,
    y: 1120.19,
    width: 448.78,
    height: 230.05,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1217.51,
    y: -8975,
    width: 448.78,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 1217.51,
    y: -8975,
    width: 448.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 384.98,
    y1: 1293.14,
    x2: 384.84,
    y2: 1293.19,
    gradientTransform: "translate(83048.25 140896.21) rotate(-180) scale(212 108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 1217.51,
    y: 1120.19,
    width: 448.78,
    height: 230.05,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1437.18,1350.24c-13.2,0-26.39-3.19-38.35-9.57l-172.81-92.14c-3.02-1.61-5.41-4.09-6.9-7.18-3.87-7.99-.54-17.64,7.42-21.52l187.42-91.42c23.4-11.41,51.08-10.91,74.05,1.33l169.75,90.48c2.95,1.57,5.31,3.99,6.81,6.98,3.98,7.93.78,17.63-7.12,21.63l-118.76,59.97c-.74.37-1.64.08-2.01-.66-.37-.74-.08-1.64.66-2.02l118.76-59.97c6.43-3.25,9.03-11.15,5.79-17.6-1.22-2.44-3.14-4.4-5.54-5.68l-169.75-90.48c-22.13-11.79-48.79-12.27-71.33-1.28l-187.42,91.42c-6.48,3.16-9.19,11.02-6.04,17.52,1.22,2.51,3.16,4.53,5.62,5.84l172.81,92.14c22.51,12,49.54,12.3,72.31.8l29.3-14.8c.74-.37,1.64-.08,2.01.66.37.74.08,1.64-.66,2.02l-29.3,14.8c-11.54,5.83-24.14,8.74-36.73,8.74Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 384.98,
    y1: 1293.14,
    x2: 384.84,
    y2: 1293.19,
    gradientTransform: "translate(83048.25 140896.21) rotate(-180) scale(212 108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b20fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e99fc"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 954.67,
    y: 996.16,
    width: 982.87,
    height: 503.36,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 954.67,
    y: -8975,
    width: 982.87,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 954.67,
    y: -8975,
    width: 982.87,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 385.6,
    y1: 1294.38,
    x2: 385.64,
    y2: 1294.47,
    gradientTransform: "translate(181143.81 309317.27) rotate(-180) scale(466 238)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 954.67,
    y: 996.16,
    width: 982.87,
    height: 503.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1435.74,1499.52c-28.72,0-57.42-6.97-83.44-20.88l-379.86-203.05c-6.3-3.37-11.28-8.56-14.41-15.02-8.07-16.7-1.13-36.9,15.48-45.02l411.97-201.46c50.91-24.9,111.15-23.81,161.15,2.9l373.13,199.38c6.16,3.29,11.07,8.34,14.21,14.6,8.3,16.59,1.64,36.88-14.86,45.23l-403.44,204.25c-25.12,12.71-52.53,19.06-79.93,19.06ZM1463.2,999.16c-26.16,0-52.34,5.86-76.4,17.63l-411.97,201.46c-15.13,7.4-21.45,25.8-14.1,41.02,2.84,5.88,7.38,10.61,13.12,13.68l379.86,203.05c49.99,26.72,110.03,27.39,160.6,1.79l403.44-204.25.68,1.34-.68-1.34c15.03-7.61,21.1-26.1,13.53-41.21-2.85-5.7-7.33-10.3-12.94-13.3l-373.13-199.38c-25.52-13.64-53.76-20.48-82.02-20.48Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 385.6,
    y1: 1294.38,
    x2: 385.64,
    y2: 1294.47,
    gradientTransform: "translate(181143.81 309317.27) rotate(-180) scale(466 238)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b20fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#620efc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 384.97,
    y1: 1293.17,
    x2: 384.54,
    y2: 1292.35,
    gradientTransform: "translate(-78706.21 134434.72) scale(205.42 -103.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4302ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f18f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 384.45,
    y1: 1292.29,
    x2: 383.25,
    y2: 1290.78,
    gradientTransform: "translate(-39152.48 108302.11) scale(103.13 -82.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4302ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9037f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 381.89,
    y1: 1292.13,
    x2: 383.75,
    y2: 1290.76,
    gradientTransform: "translate(-39092.26 108302.11) scale(102.71 -82.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f18f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 384.16,
    y1: 1291.18,
    x2: 384.92,
    y2: 1290.93,
    gradientTransform: "translate(-61940.86 85756.9) scale(162 -65.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b00a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b0ce7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 384.97,
    y1: 1293.81,
    x2: 384.54,
    y2: 1293,
    gradientTransform: "translate(-78706.21 134374.72) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 384.45,
    y1: 1293.08,
    x2: 383.25,
    y2: 1291.58,
    gradientTransform: "translate(-39152.48 108242.11) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 381.89,
    y1: 1292.93,
    x2: 383.75,
    y2: 1291.56,
    gradientTransform: "translate(-39092.26 108242.11) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 384.16,
    y1: 1292.19,
    x2: 384.92,
    y2: 1291.94,
    gradientTransform: "translate(-61940.86 85696.9) scale(162 -65.45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 384.97,
    y1: 1294.45,
    x2: 384.54,
    y2: 1293.63,
    gradientTransform: "translate(-78706.21 134315.11) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 384.45,
    y1: 1293.88,
    x2: 383.25,
    y2: 1292.38,
    gradientTransform: "translate(-39152.48 108182.49) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 381.89,
    y1: 1293.72,
    x2: 383.75,
    y2: 1292.36,
    gradientTransform: "translate(-39092.26 108182.49) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 384.16,
    y1: 1293.24,
    x2: 384.92,
    y2: 1292.99,
    gradientTransform: "translate(-61940.86 85634.76) scale(162 -65.45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 384.97,
    y1: 1295.12,
    x2: 384.54,
    y2: 1294.31,
    gradientTransform: "translate(-78706.21 134252.18) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 383.39,
    y1: 1294.13,
    x2: 384.15,
    y2: 1293.79,
    gradientTransform: "translate(-43274.55 71019.56) scale(113.66 -54.22)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 384.22,
    y1: 1295.44,
    x2: 383.79,
    y2: 1294.63,
    gradientTransform: "translate(-51734.83 88824.48) scale(135.57 -68)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 382.95,
    y1: 1295.17,
    x2: 382.52,
    y2: 1294.36,
    gradientTransform: "translate(-32588.82 56435) scale(86 -43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8200ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 382.96,
    y1: 1295.11,
    x2: 381.76,
    y2: 1293.61,
    gradientTransform: "translate(-25628.94 71576.64) scale(68.07 -54.67)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 380.38,
    y1: 1294.95,
    x2: 382.24,
    y2: 1293.59,
    gradientTransform: "translate(-25589.02 71576.64) scale(67.79 -54.67)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 384.45,
    y1: 1294.72,
    x2: 383.25,
    y2: 1293.21,
    gradientTransform: "translate(-39152.48 108119.64) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 381.89,
    y1: 1294.56,
    x2: 383.75,
    y2: 1293.19,
    gradientTransform: "translate(-39092.26 108119.64) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 0,
    y: 1135.04,
    width: 641.66,
    height: 328.86,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 0,
    y: -8975,
    width: 641.66,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 0,
    y: -8975,
    width: 641.66,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 385.25,
    y1: 1293.42,
    x2: 385.12,
    y2: 1293.57,
    gradientTransform: "translate(-116677.17 201786.87) scale(303.73 -155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 0,
    y: 1135.04,
    width: 641.66,
    height: 328.86,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M327.58,1463.9c-17.94,0-35.88-4.15-52.33-12.47L12.3,1318.42c-11.01-5.57-15.46-19.1-9.92-30.16,2.09-4.18,5.37-7.54,9.48-9.74l243.2-129.85c32.73-17.48,72.18-18.19,105.51-1.9l268.51,131.2c11.08,5.42,15.72,18.88,10.33,30.02-2.08,4.3-5.41,7.77-9.61,10.01l-247.58,132.24c-17.04,9.1-35.83,13.66-54.63,13.66ZM183.8,1401.81l92.81,46.95c32.81,16.6,71.76,16.16,104.2-1.16l247.58-132.24c3.64-1.95,6.52-4.95,8.33-8.67,4.67-9.65.66-21.32-8.95-26.02l-268.51-131.2c-32.47-15.87-70.89-15.18-102.78,1.85L13.28,1281.17c-3.56,1.9-6.4,4.82-8.21,8.44-4.8,9.59-.95,21.31,8.59,26.14l170.14,86.07Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 385.25,
    y1: 1293.42,
    x2: 385.12,
    y2: 1293.57,
    gradientTransform: "translate(-116677.17 201786.87) scale(303.73 -155)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 235.62,
    y: 348.33,
    width: 90.3,
    height: 458.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 235.62,
    y: -8975,
    width: 90.3,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 235.62,
    y: -8975,
    width: 90.3,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 378.7,
    y1: 1293.26,
    x2: 378.7,
    y2: 1296.54,
    gradientTransform: "translate(-15981.69 282830.03) scale(42.94 -217.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 235.62,
    y: 348.33,
    width: 90.3,
    height: 458.03,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93",
    className: "cls-120",
    points: "235.62 762.2 235.62 348.33 325.6 389.42 325.92 806.36 235.62 762.2"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 378.7,
    y1: 1293.26,
    x2: 378.7,
    y2: 1296.54,
    gradientTransform: "translate(-15981.69 282830.03) scale(42.94 -217.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8200ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4aff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 326.04,
    y: 348.33,
    width: 89.7,
    height: 458.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 326.04,
    y: -8975,
    width: 89.7,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 326.04,
    y: -8975,
    width: 89.7,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 392.63,
    y1: 1293.26,
    x2: 392.63,
    y2: 1296.54,
    gradientTransform: "translate(17118.99 282830.03) rotate(-180) scale(42.66 217.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 326.04,
    y: 348.33,
    width: 89.7,
    height: 458.03,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy",
    className: "cls-38",
    points: "415.74 762.2 415.74 348.33 326.04 387.85 326.04 806.36 415.74 762.2"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 392.63,
    x2: 392.63,
    gradientTransform: "translate(17118.99 282830.03) rotate(-180) scale(42.66 217.82)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 262.24,
    y: 488.84,
    width: 63.08,
    height: 317.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 262.24,
    y: -8975,
    width: 63.08,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 262.24,
    y: -8975,
    width: 63.08,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 375.7,
    y1: 1294.37,
    x2: 375.7,
    y2: 1296.43,
    gradientTransform: "translate(-10977.18 196295) scale(30 -151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 262.24,
    y: 488.84,
    width: 63.08,
    height: 317.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-3",
    "data-name": "Path-93",
    className: "cls-73",
    points: "262.24 775.75 262.24 488.84 325.09 517.33 325.32 806.36 262.24 775.75"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 375.7,
    y1: 1294.37,
    x2: 375.7,
    y2: 1296.43,
    gradientTransform: "translate(-10977.18 196295) scale(30 -151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4aff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 325.32,
    y: 488.84,
    width: 63.08,
    height: 317.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 325.32,
    y: -8975,
    width: 63.08,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 325.32,
    y: -8975,
    width: 63.08,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 395.59,
    y1: 1294.37,
    x2: 395.59,
    y2: 1296.43,
    gradientTransform: "translate(12224.58 196295) rotate(-180) scale(30 151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 325.32,
    y: 488.84,
    width: 63.08,
    height: 317.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-3",
    "data-name": "Path-93-Copy",
    className: "cls-4",
    points: "388.4 775.75 388.4 488.84 325.32 516.24 325.32 806.36 388.4 775.75"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 395.59,
    x2: 395.59,
    gradientTransform: "translate(12224.58 196295) rotate(-180) scale(30 151)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 327.42,
    y: 1300.51,
    width: 567.99,
    height: 279.55,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 327.42,
    y: -8975,
    width: 567.99,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 327.42,
    y: -8975,
    width: 567.99,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 383,
    y1: 1293.23,
    x2: 386.22,
    y2: 1292.43,
    gradientTransform: "translate(-103558.28 173277.43) scale(270.12 -132.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 327.42,
    y: 1300.51,
    width: 567.99,
    height: 279.55,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-89-Copy-3",
    className: "cls-97",
    points: "327.42 1413.11 667.45 1580.06 895.42 1466.3 541.73 1300.51 327.42 1413.11"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 383,
    y1: 1293.23,
    x2: 386.22,
    y2: 1292.43,
    gradientTransform: "translate(-103558.28 173277.43) scale(270.12 -132.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c99aff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 501.42,
    y: 1378.07,
    width: 672.4,
    height: 190,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 501.42,
    y: -8975,
    width: 672.4,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 501.42,
    y: -8975,
    width: 672.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 386.02,
    y1: 1291.32,
    x2: 386.06,
    y2: 1291.37,
    gradientTransform: "translate(-122075.2 116277.55) scale(318.34 -88.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 501.42,
    y: 1378.07,
    width: 672.4,
    height: 190,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M877.93,1568.07c-.23,0-.46-.05-.67-.16l-375.01-187c-.74-.37-1.04-1.27-.67-2.01.37-.74,1.27-1.04,2.01-.67l374.33,186.66,293.72-150.06c.74-.38,1.64-.08,2.02.65.38.74.08,1.64-.65,2.02l-294.39,150.41c-.21.11-.45.16-.68.16Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 386.02,
    y1: 1291.32,
    x2: 386.06,
    y2: 1291.37,
    gradientTransform: "translate(-122075.2 116277.55) scale(318.34 -88.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 1394.58,
    y: 1225,
    width: 412.06,
    height: 203.83,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-20",
    x: 1394.58,
    y: -8975,
    width: 412.06,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 1394.58,
    y: -8975,
    width: 412.06,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 385.36,
    y1: 1293.05,
    x2: 388.58,
    y2: 1292.24,
    gradientTransform: "translate(-74432.32 126602.55) scale(195.96 -96.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 1394.58,
    y: 1225,
    width: 412.06,
    height: 203.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-85-Copy",
    className: "cls-130",
    d: "M1394.58,1257.88l331.94,170.96,80.11-40.86-312.84-162.97c-4.81,22.19-25.12,37.54-47.78,36.11l-51.44-3.24h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 385.36,
    y1: 1293.05,
    x2: 388.58,
    y2: 1292.24,
    gradientTransform: "translate(-74432.32 126602.55) scale(195.96 -96.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c99aff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-21",
    x: 755.34,
    y: 118.77,
    width: 597.55,
    height: 784.47,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-22",
    x: 755.34,
    y: -8975,
    width: 597.55,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 755.34,
    y: -8975,
    width: 597.55,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 386.58,
    y1: 1297.56,
    x2: 386.34,
    y2: 1294.31,
    gradientTransform: "translate(-108769.35 484001.17) scale(284.17 -373.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 755.34,
    y: 118.77,
    width: 597.55,
    height: 784.47,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy",
    className: "cls-40",
    d: "M772.53,399.35L1330.4,120.42c7.68-3.84,17.01-.73,20.85,6.95,1.08,2.16,1.64,4.54,1.64,6.95v465.48c0,11.85-6.74,22.68-17.38,27.9l-557.77,273.95c-7.71,3.78-17.02.61-20.8-7.1-1.05-2.13-1.59-4.48-1.59-6.85v-460.54c0-11.78,6.65-22.54,17.18-27.81Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 386.58,
    y1: 1297.56,
    x2: 386.34,
    y2: 1294.31,
    gradientTransform: "translate(-108769.35 484001.17) scale(284.17 -373.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4302ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f18f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 386.75,
    y1: 1297.49,
    x2: 386.51,
    y2: 1294.25,
    gradientTransform: "translate(-108727.5 484023.17) scale(284.17 -373.07)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 843.33,
    y: 165.05,
    width: 597.55,
    height: 910.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-8-2",
    "data-name": "mask-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7-2",
    "data-name": "path-7",
    className: "cls-111",
    d: "M860.52,445.63l557.87-278.93c7.68-3.84,17.01-.73,20.85,6.95,1.08,2.16,1.64,4.54,1.64,6.95v465.48c0,11.85-6.74,22.68-17.38,27.9l-557.77,273.95c-7.71,3.78-17.02.61-20.8-7.1-1.05-2.13-1.59-4.48-1.59-6.85v-460.54c0-11.78,6.65-22.54,17.18-27.81Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 797,
    y: 165.05,
    width: 643.88,
    height: 784.47,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-8-3",
    "data-name": "mask-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7-3",
    "data-name": "path-7",
    className: "cls-111",
    d: "M860.52,445.63l557.87-278.93c7.68-3.84,17.01-.73,20.85,6.95,1.08,2.16,1.64,4.54,1.64,6.95v465.48c0,11.85-6.74,22.68-17.38,27.9l-557.77,273.95c-7.71,3.78-17.02.61-20.8-7.1-1.05-2.13-1.59-4.48-1.59-6.85v-460.54c0-11.78,6.65-22.54,17.18-27.81Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 387.84,
    y1: 1301.24,
    x2: 386.68,
    y2: 1296.19,
    gradientTransform: "translate(-5618.29 45834.26) scale(16.92 -34.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd53e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 389.01,
    y1: 1301.09,
    x2: 388.42,
    y2: 1296.04,
    gradientTransform: "translate(-5596.97 64944.39) scale(16.93 -49.53)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 389.15,
    y1: 1298.36,
    x2: 385.12,
    y2: 1295.58,
    gradientTransform: "translate(-58534.25 175803.56) scale(154.37 -135.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aad1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18b9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 389.15,
    y1: 1297.56,
    x2: 385.12,
    y2: 1294.77,
    gradientTransform: "translate(-58534.25 175902.04) scale(154.37 -135.2)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 409.89,
    y1: 1328.31,
    x2: 408.36,
    y2: 1326.4,
    gradientTransform: "translate(-1441 10122.13) rotate(-1) scale(6.87 -7.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0275ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18b9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 398.27,
    y1: 1313.78,
    x2: 395.09,
    y2: 1311.62,
    gradientTransform: "translate(-4528.42 17504.08) rotate(-1) scale(15.2 -12.93)",
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 410.2,
    y1: 1313.26,
    x2: 407.27,
    y2: 1311.83,
    gradientTransform: "translate(-1441 10220.61) rotate(-1) scale(6.87 -7.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c402ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18b9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 398.34,
    y1: 1304.87,
    x2: 393.47,
    y2: 1303.43,
    gradientTransform: "translate(-4528.42 17602.56) rotate(-1) scale(15.2 -12.93)",
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 409.14,
    y1: 1298.06,
    x2: 407.14,
    y2: 1295.19,
    gradientTransform: "translate(-1441 10320.61) rotate(-1) scale(6.87 -7.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff791a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd53e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 399.98,
    y1: 1299.43,
    x2: 395.12,
    y2: 1294.38,
    gradientTransform: "translate(-4528.42 17702.56) rotate(-1) scale(15.2 -12.93)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 384.24,
    y1: 1302.83,
    x2: 384.06,
    y2: 1299.59,
    gradientTransform: "translate(-25391.63 119004.96) scale(68 -91.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 388.38,
    y1: 1303.36,
    x2: 388.2,
    y2: 1300.11,
    gradientTransform: "translate(-17923.66 85952.01) scale(49 -65.97)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 395.71,
    y1: 1306.11,
    x2: 395.54,
    y2: 1302.87,
    gradientTransform: "translate(-11933.22 59998.8) scale(34 -45.94)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 395.5,
    y1: 1295.32,
    x2: 395.34,
    y2: 1293.7,
    gradientTransform: "translate(-15896.33 84956.14) rotate(3) scale(32.8 -65.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c9eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9faff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 394.25,
    y1: 1295.34,
    x2: 394.03,
    y2: 1293.44,
    gradientTransform: "translate(-13049.04 197761.07) scale(36.87 -151.95)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 1443.76,
    y: 922.71,
    width: 97.74,
    height: 334.75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-24-2",
    "data-name": "mask-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-23-2",
    "data-name": "path-23",
    className: "cls-111",
    d: "M1443.76,943.76c27.79,168.31,44.98,264.42,51.57,288.34,4.41,15.99,26.24,11.79,25.95-3.76.29-43.7-3.25-90.48-10.62-140.34-2.35-15.94-1.69-48.79-2.9-63.71-2.65-32.89-5.23-43.67-7-67.05-.66-8.74-5.01-20.25-13.03-34.52l-43.97,21.05Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 393.27,
    y1: 1295.32,
    x2: 393.03,
    y2: 1293.42,
    gradientTransform: "translate(-13806.33 201360.68) scale(38.79 -154.72)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 1405.72,
    y: 935.87,
    width: 81.56,
    height: 338.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-26-2",
    "data-name": "path-26",
    className: "cls-111",
    d: "M1405.72,968.32c6.56,161.42,9.84,255.72,9.84,282.91,0,3.45,2.49,8.56,10.16,9.79,7.67,1.24,13.26-3.74,14.15-6.7,8.23-52.14,12.34-96.9,12.34-134.27,0-15.52,4.58-40.8,5.46-59.78.57-12.4,1.03-32.29,1.37-59.68l20.22-22.14c6.12-6.7,8.96-15.77,7.74-24.76l-2.4-17.82h0l-78.88,32.45Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 391.21,
    y1: 1295.79,
    x2: 390.57,
    y2: 1293.89,
    gradientTransform: "translate(-21985.08 183081.93) scale(59.98 -140.68)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 1386.18,
    y: 771.64,
    width: 134.33,
    height: 314.56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-29-2",
    "data-name": "path-29",
    className: "cls-111",
    d: "M1401.54,810.78l-7.15,245.43c-.12,4.18,3,7.75,7.17,8.18,40.05,4.14,66.22,4.09,78.5-.15,12.28-4.24,25.19-17.69,38.75-40.34,1.59-2.66,2.09-5.83,1.4-8.84l-28.02-121.91h0l1.57-99.86c.18-11.77-9.21-21.46-20.98-21.65-2.62-.04-5.23.4-7.68,1.3-12.52,4.6-22.33,8.61-29.42,12.04-11.89,5.74-23.26,14.34-34.12,25.8Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27-2",
    "data-name": "mask-27",
    x: 1394.39,
    y: 771.64,
    width: 126.12,
    height: 295.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-30-2",
    "data-name": "mask-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-29-3",
    "data-name": "path-29",
    className: "cls-111",
    d: "M1401.54,810.78l-7.15,245.43c-.12,4.18,3,7.75,7.17,8.18,40.05,4.14,66.22,4.09,78.5-.15,12.28-4.24,25.19-17.69,38.75-40.34,1.59-2.66,2.09-5.83,1.4-8.84l-28.02-121.91h0l1.57-99.86c.18-11.77-9.21-21.46-20.98-21.65-2.62-.04-5.23.4-7.68,1.3-12.52,4.6-22.33,8.61-29.42,12.04-11.89,5.74-23.26,14.34-34.12,25.8Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 395.17,
    y1: 1295.98,
    x2: 394.54,
    y2: 1293.63,
    gradientTransform: "translate(-10143.34 106931.96) scale(29.24 -81.91)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 379.32,
    y1: 1297.59,
    x2: 377.6,
    y2: 1293.41,
    gradientTransform: "translate(17521.37 37302.52) rotate(170) scale(24.87 30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b54bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18b9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 375.53,
    y1: 1298.02,
    x2: 373.68,
    y2: 1293.84,
    gradientTransform: "translate(12723.34 25908.57) rotate(170) scale(17.73 20.7)",
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 382.43,
    y1: 1290.57,
    x2: 382,
    y2: 1289.75,
    gradientTransform: "translate(-77819.21 134334.72) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 379.39,
    y1: 1289.05,
    x2: 378.19,
    y2: 1287.55,
    gradientTransform: "translate(-38265.48 108202.11) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 376.8,
    y1: 1288.89,
    x2: 378.66,
    y2: 1287.53,
    gradientTransform: "translate(-38205.26 108202.11) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 380.93,
    y1: 1287.08,
    x2: 381.69,
    y2: 1286.83,
    gradientTransform: "translate(-61053.86 85656.9) scale(162 -65.45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 382.43,
    y1: 1291.2,
    x2: 382,
    y2: 1290.39,
    gradientTransform: "translate(-77819.21 134275.11) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 379.39,
    y1: 1289.84,
    x2: 378.19,
    y2: 1288.34,
    gradientTransform: "translate(-38265.48 108142.49) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 376.8,
    y1: 1289.69,
    x2: 378.66,
    y2: 1288.32,
    gradientTransform: "translate(-38205.26 108142.49) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 380.93,
    y1: 1288.13,
    x2: 381.69,
    y2: 1287.88,
    gradientTransform: "translate(-61053.86 85594.76) scale(162 -65.45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 382.43,
    y1: 1291.88,
    x2: 382,
    y2: 1291.06,
    gradientTransform: "translate(-77819.21 134212.18) scale(205.42 -103.03)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 379.39,
    y1: 1290.68,
    x2: 378.19,
    y2: 1289.18,
    gradientTransform: "translate(-38265.48 108079.64) scale(103.13 -82.83)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 376.8,
    y1: 1290.52,
    x2: 378.66,
    y2: 1289.16,
    gradientTransform: "translate(-38205.26 108079.64) scale(102.71 -82.83)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 378.8,
    y1: 1287.96,
    x2: 379.56,
    y2: 1287.63,
    gradientTransform: "translate(-42387.55 70979.56) scale(113.66 -54.22)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 380.37,
    y1: 1290.53,
    x2: 379.94,
    y2: 1289.71,
    gradientTransform: "translate(-50847.83 88784.48) scale(135.57 -68)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 376.42,
    y1: 1286.95,
    x2: 375.99,
    y2: 1286.14,
    gradientTransform: "translate(-30157.03 53805) scale(82 -41)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 375.29,
    y1: 1288.99,
    x2: 374.09,
    y2: 1287.49,
    gradientTransform: "translate(-24741.94 71536.64) scale(68.07 -54.67)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 372.68,
    y1: 1288.84,
    x2: 374.54,
    y2: 1287.47,
    gradientTransform: "translate(-24702.02 71536.64) scale(67.79 -54.67)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-23",
    x: 366.93,
    y: 1307.47,
    width: 641.66,
    height: 328.86,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-24",
    x: 366.93,
    y: -8975,
    width: 641.66,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 366.93,
    y: -8975,
    width: 641.66,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 383.54,
    y1: 1291.68,
    x2: 383.41,
    y2: 1291.83,
    gradientTransform: "translate(-115789.17 201688.87) scale(303.73 -155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    x: 366.93,
    y: 1307.47,
    width: 641.66,
    height: 328.86,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M694.52,1636.33c-17.94,0-35.89-4.15-52.33-12.47l-262.95-133.02c-11.01-5.57-15.46-19.1-9.92-30.16,2.09-4.18,5.37-7.54,9.48-9.74l243.2-129.85c32.73-17.48,72.18-18.19,105.51-1.9l268.51,131.2c11.08,5.42,15.72,18.88,10.33,30.02-2.08,4.3-5.41,7.77-9.61,10.01l-247.58,132.24c-17.04,9.1-35.83,13.66-54.63,13.66ZM550.73,1574.24l92.81,46.95c32.81,16.6,71.76,16.16,104.19-1.16l247.58-132.24c3.64-1.95,6.52-4.94,8.33-8.67,4.67-9.65.66-21.32-8.95-26.02l-268.51-131.2c-32.47-15.87-70.89-15.18-102.78,1.85l-243.2,129.85c-3.56,1.9-6.4,4.82-8.21,8.43-4.8,9.59-.95,21.31,8.59,26.14l170.14,86.07Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 383.54,
    y1: 1291.68,
    x2: 383.41,
    y2: 1291.83,
    gradientTransform: "translate(-115789.17 201688.87) scale(303.73 -155)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-25",
    x: 599.73,
    y: 642.34,
    width: 90.3,
    height: 458.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-26",
    x: 599.73,
    y: -8975,
    width: 90.3,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 599.73,
    y: -8975,
    width: 90.3,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 366.53,
    y1: 1291.73,
    x2: 366.53,
    y2: 1295.01,
    gradientTransform: "translate(-15095.04 282789.86) scale(42.94 -217.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30-3",
    "data-name": "mask-30",
    x: 599.73,
    y: 642.34,
    width: 90.3,
    height: 458.03,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-5",
    "data-name": "Path-93",
    className: "cls-23",
    points: "599.73 1056.22 599.73 642.34 689.7 683.43 690.03 1100.38 599.73 1056.22"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 366.53,
    y1: 1291.73,
    x2: 366.53,
    y2: 1295.01,
    gradientTransform: "translate(-15095.04 282789.86) scale(42.94 -217.82)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-27",
    x: 690.15,
    y: 642.34,
    width: 89.7,
    height: 458.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-28",
    x: 690.15,
    y: -8975,
    width: 89.7,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    x: 690.15,
    y: -8975,
    width: 89.7,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 404.88,
    y1: 1291.73,
    x2: 404.88,
    y2: 1295.01,
    gradientTransform: "translate(18005.65 282789.86) rotate(-180) scale(42.66 217.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    x: 690.15,
    y: 642.34,
    width: 89.7,
    height: 458.03,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-5",
    "data-name": "Path-93-Copy",
    className: "cls-91",
    points: "779.85 1056.22 779.85 642.34 690.15 681.87 690.15 1100.38 779.85 1056.22"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 404.88,
    y1: 1291.73,
    x2: 404.88,
    y2: 1295.01,
    gradientTransform: "translate(18005.65 282789.86) rotate(-180) scale(42.66 217.82)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-29",
    x: 626.35,
    y: 782.86,
    width: 63.08,
    height: 317.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-30",
    x: 626.35,
    y: -8975,
    width: 63.08,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    x: 626.35,
    y: -8975,
    width: 63.08,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 358.28,
    y1: 1292.15,
    x2: 358.28,
    y2: 1294.21,
    gradientTransform: "translate(-10090.53 196254.82) scale(30 -151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    x: 626.35,
    y: 782.86,
    width: 63.08,
    height: 317.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-7",
    "data-name": "Path-93",
    className: "cls-36",
    points: "626.35 1069.76 626.35 782.86 689.2 811.34 689.43 1100.38 626.35 1069.76"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 358.28,
    y1: 1292.15,
    x2: 358.28,
    y2: 1294.21,
    gradientTransform: "translate(-10090.53 196254.82) scale(30 -151)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-31",
    x: 689.43,
    y: 782.86,
    width: 63.08,
    height: 317.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-32",
    x: 689.43,
    y: -8975,
    width: 63.08,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    x: 689.43,
    y: -8975,
    width: 63.08,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 413.01,
    y1: 1292.15,
    x2: 413.01,
    y2: 1294.21,
    gradientTransform: "translate(13111.23 196254.82) rotate(-180) scale(30 151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    x: 689.43,
    y: 782.86,
    width: 63.08,
    height: 317.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-7",
    "data-name": "Path-93-Copy",
    className: "cls-109",
    points: "752.51 1069.76 752.51 782.86 689.43 810.25 689.43 1100.38 752.51 1069.76"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 413.01,
    y1: 1292.15,
    x2: 413.01,
    y2: 1294.21,
    gradientTransform: "translate(13111.23 196254.82) rotate(-180) scale(30 151)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-33",
    x: 688.05,
    y: 1470.84,
    width: 567.99,
    height: 279.55,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-34",
    x: 688.05,
    y: -8975,
    width: 567.99,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    x: 688.05,
    y: -8975,
    width: 567.99,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 381.06,
    y1: 1291.2,
    x2: 384.28,
    y2: 1290.4,
    gradientTransform: "translate(-102673.28 173178.43) scale(270.12 -132.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    x: 688.05,
    y: 1470.84,
    width: 567.99,
    height: 279.55,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-89-Copy-2",
    className: "cls-139",
    points: "688.05 1583.44 1028.07 1750.38 1256.04 1636.62 902.36 1470.84 688.05 1583.44"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 381.06,
    y1: 1291.2,
    x2: 384.28,
    y2: 1290.4,
    gradientTransform: "translate(-102673.28 173178.43) scale(270.12 -132.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c99aff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 398.28,
    y1: 1299.74,
    x2: 397.6,
    y2: 1299.36,
    gradientTransform: "translate(-11924.72 70752.82) scale(34.42 -54.17)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 374.88,
    y1: 1300.18,
    x2: 374.51,
    y2: 1299.43,
    gradientTransform: "translate(14628.94 70752.82) rotate(-180) scale(34.42 54.17)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 392.52,
    y1: 1302.5,
    x2: 391.91,
    y2: 1301.6,
    gradientTransform: "translate(-25236.06 45629.36) scale(68.85 -34.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4302ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d218f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 393.56,
    y1: 1298.1,
    x2: 392.88,
    y2: 1297.73,
    gradientTransform: "translate(-20953.63 118482.27) scale(57.83 -91.01)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 379.61,
    y1: 1298.55,
    x2: 379.24,
    y2: 1297.79,
    gradientTransform: "translate(23657.08 118482.27) rotate(-180) scale(57.83 91.01)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 389.79,
    y1: 1299.48,
    x2: 389.57,
    y2: 1299.05,
    gradientTransform: "translate(-43316.32 76275.64) scale(115.66 -58.47)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 392.29,
    y1: 1291.39,
    x2: 390.71,
    y2: 1290.51,
    gradientTransform: "translate(-12245.72 71312.82) scale(34.42 -54.17)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 383.21,
    y1: 1292.42,
    x2: 382.35,
    y2: 1290.66,
    gradientTransform: "translate(14307.94 71312.82) rotate(-180) scale(34.42 54.17)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 388.71,
    y1: 1289.95,
    x2: 388.19,
    y2: 1288.96,
    gradientTransform: "translate(-25557.06 46189.36) scale(68.85 -34.8)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 390.47,
    y1: 1293.16,
    x2: 388.9,
    y2: 1292.28,
    gradientTransform: "translate(-21274.63 119042.27) scale(57.83 -91.01)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 385.04,
    y1: 1294.19,
    x2: 384.18,
    y2: 1292.43,
    gradientTransform: "translate(23336.08 119042.27) rotate(-180) scale(57.83 91.01)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 387.8,
    y1: 1292.72,
    x2: 387.28,
    y2: 1291.73,
    gradientTransform: "translate(-43637.32 76835.64) scale(115.66 -58.47)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 395.89,
    y1: 1285.9,
    x2: 394.94,
    y2: 1285.37,
    gradientTransform: "translate(-16608.62 92461.25) scale(45.09 -70.97)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 377.98,
    y1: 1286.52,
    x2: 377.47,
    y2: 1285.46,
    gradientTransform: "translate(18177.03 92461.25) rotate(-180) scale(45.09 70.97)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 391.33,
    y1: 1281.45,
    x2: 390.48,
    y2: 1280.19,
    gradientTransform: "translate(-34045.96 59550.17) scale(90.19 -45.59)",
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 392.28,
    y1: 1289.88,
    x2: 391.33,
    y2: 1289.35,
    gradientTransform: "translate(-28436.22 154987.32) scale(75.76 -119.22)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 381.59,
    y1: 1290.5,
    x2: 381.08,
    y2: 1289.44,
    gradientTransform: "translate(30003.58 154987.32) rotate(-180) scale(75.76 119.22)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 389.01,
    y1: 1286.95,
    x2: 388.7,
    y2: 1286.36,
    gradientTransform: "translate(-57731.42 99696.61) scale(151.52 -76.59)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-35",
    x: 1703.87,
    y: 1039.97,
    width: 317.03,
    height: 140.81,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-36",
    x: 1703.87,
    y: -8975,
    width: 317.03,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    x: 1703.87,
    y: -8975,
    width: 317.03,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 386.89,
    y1: 1294.24,
    x2: 390.11,
    y2: 1293.59,
    gradientTransform: "translate(-56865.75 87738.97) scale(150.77 -66.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    x: 1703.87,
    y: 1039.97,
    width: 317.03,
    height: 140.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-94",
    className: "cls-131",
    points: "1703.87 1049.68 1982.48 1180.78 2020.9 1160.95 1792.19 1048.96 1741.58 1039.97 1703.87 1049.68"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 386.89,
    y1: 1294.24,
    x2: 390.11,
    y2: 1293.59,
    gradientTransform: "translate(-56865.75 87738.97) scale(150.77 -66.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2aaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c99aff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 377.6,
    y1: 1297.14,
    x2: 379.08,
    y2: 1297.61,
    gradientTransform: "translate(24025.31 91515.87) rotate(-180) scale(58.78 70.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaa86f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d06f3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 378.83,
    y1: 1298.25,
    x2: 380.16,
    y2: 1297.37,
    gradientTransform: "translate(24493.77 62509.57) rotate(-180) scale(60.13 47.65)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 370.78,
    y1: 1294.44,
    x2: 370.99,
    y2: 1296.3,
    gradientTransform: "translate(13012.49 130103.55) rotate(-180) scale(30.26 99.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe7db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8c5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 367.71,
    y1: 1294.57,
    x2: 367.83,
    y2: 1296.43,
    gradientTransform: "translate(10301.87 132461.24) rotate(-180) scale(23.32 101.54)",
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 378.2,
    y1: 1297.02,
    x2: 376.6,
    y2: 1294.83,
    gradientTransform: "translate(21179.86 80457.52) rotate(-180) scale(51.45 61.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d76ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa4e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 377.35,
    y1: 1297.47,
    x2: 375.87,
    y2: 1295.57,
    gradientTransform: "translate(19221.04 95595.32) rotate(-180) scale(46.38 73.18)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 375.49,
    y1: 1298.2,
    x2: 376.33,
    y2: 1296.06,
    gradientTransform: "translate(19163.94 77193.55) rotate(-180) scale(46.18 58.98)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 343.36,
    y1: 1298.5,
    x2: 343.59,
    y2: 1300.64,
    gradientTransform: "translate(5352.36 43503.12) rotate(-180) scale(10.46 32.99)",
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 360.9,
    y1: 1300.75,
    x2: 362.61,
    y2: 1302.89,
    gradientTransform: "translate(9829.14 27983.04) rotate(177) scale(18.33 21.34)",
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 379.98,
    y1: 1298.84,
    x2: 377.32,
    y2: 1298.78,
    gradientTransform: "translate(26706.75 35237.87) rotate(-180) scale(65.81 26.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5972fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9faff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 379.93,
    y1: 1298.83,
    x2: 377.37,
    y2: 1296.3,
    gradientTransform: "translate(21448.79 71264.7) rotate(-180) scale(52.25 54.4)",
    xlinkHref: "#linear-gradient-121"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path-Copy-4",
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1437.18,1350.24c-13.2,0-26.39-3.19-38.35-9.57l-172.81-92.14c-3.02-1.61-5.41-4.09-6.9-7.18-3.87-7.99-.54-17.64,7.42-21.52l187.42-91.42c23.4-11.41,51.08-10.91,74.05,1.33l169.75,90.48c2.95,1.57,5.31,3.99,6.81,6.98,3.98,7.93.78,17.63-7.12,21.63l-118.76,59.97c-.74.37-1.64.08-2.01-.66-.37-.74-.08-1.64.66-2.02l118.76-59.97c6.43-3.25,9.03-11.15,5.79-17.6-1.22-2.44-3.14-4.4-5.54-5.68l-169.75-90.48c-22.13-11.79-48.79-12.27-71.33-1.28l-187.42,91.42c-6.48,3.16-9.19,11.02-6.04,17.52,1.22,2.51,3.16,4.53,5.62,5.84l172.81,92.14c22.51,12,49.54,12.3,72.31.8l29.3-14.8c.74-.37,1.64-.08,2.01.66.37.74.08,1.64-.66,2.02l-29.3,14.8c-11.54,5.83-24.14,8.74-36.73,8.74Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path-Copy-5",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1435.74,1499.52c-28.72,0-57.42-6.97-83.44-20.88l-379.86-203.05c-6.3-3.37-11.28-8.56-14.41-15.02-8.07-16.7-1.13-36.9,15.48-45.02l411.97-201.46c50.91-24.9,111.15-23.81,161.15,2.9l373.13,199.38c6.16,3.29,11.07,8.34,14.21,14.6,8.3,16.59,1.64,36.88-14.86,45.23l-403.44,204.25c-25.12,12.71-52.53,19.06-79.93,19.06ZM1463.2,999.16c-26.16,0-52.34,5.86-76.4,17.63l-411.97,201.46c-15.13,7.4-21.45,25.8-14.1,41.02,2.84,5.88,7.38,10.61,13.12,13.68l379.86,203.05c49.99,26.72,110.03,27.39,160.6,1.79l403.44-204.25.68,1.34-.68-1.34c15.03-7.61,21.1-26.1,13.53-41.21-2.85-5.7-7.33-10.3-12.94-13.3l-373.13-199.38c-25.52-13.64-53.76-20.48-82.02-20.48Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64",
    className: "cls-37",
    points: "110.84 1240.36 327.54 1133 542.78 1240.36 325.92 1349.65 110.84 1240.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65",
    className: "cls-16",
    points: "325.92 1349.65 326.81 1414.53 542.78 1302.03 542.78 1240.36 325.92 1349.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66",
    className: "cls-76",
    points: "110.84 1240.36 110.84 1308.16 326.81 1414.53 326.81 1349.65 110.84 1240.36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-Copy-2",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169,1336.4h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-Copy-3",
    className: "cls-99",
    points: "153.08 1250.69 325.96 1336.02 493.73 1246.29 493.73 1198.4 326.94 1285.72 153.08 1199.85 153.08 1250.69"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-2",
    "data-name": "Path-64",
    className: "cls-83",
    points: "110.84 1114.19 327.54 1006.83 542.78 1114.19 325.92 1223.48 110.84 1114.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-2",
    "data-name": "Path-65",
    className: "cls-126",
    points: "325.92 1223.48 326.81 1288.36 542.78 1175.86 542.78 1114.19 325.92 1223.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-2",
    "data-name": "Path-66",
    className: "cls-29",
    points: "110.84 1114.19 110.84 1181.99 326.81 1288.36 326.81 1223.48 110.84 1114.19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-Copy-2-2",
    "data-name": "Path-69-Copy-2",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169,1210.24h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-Copy",
    className: "cls-3",
    points: "153.08 1124.52 325.96 1209.86 493.73 1120.12 493.73 1072.24 326.94 1159.56 153.08 1073.69 153.08 1124.52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-3",
    "data-name": "Path-64",
    className: "cls-52",
    points: "110.84 988.84 327.54 881.47 542.78 988.84 325.92 1098.12 110.84 988.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-3",
    "data-name": "Path-65",
    className: "cls-64",
    points: "325.92 1098.12 326.81 1163.01 542.78 1050.5 542.78 988.84 325.92 1098.12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M509.42,1050.07c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M478.74,1066.49c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68-2",
    "data-name": "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M509.42,1172.7c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-2",
    "data-name": "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M478.74,1189.12c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.33,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M509.42,1298.87c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M478.74,1315.29c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-3",
    "data-name": "Path-66",
    className: "cls-28",
    points: "110.84 988.84 110.84 1056.63 326.81 1163.01 326.81 1098.12 110.84 988.84"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67",
    className: "cls-56",
    points: "153.08 993.71 325.96 1079.05 493.73 989.31 493.73 941.43 326.94 1028.75 153.08 942.88 153.08 993.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-4",
    "data-name": "Path-64",
    className: "cls-5",
    points: "110.84 856.66 327.54 749.3 542.78 856.66 325.92 965.95 110.84 856.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-Copy-2",
    className: "cls-105",
    points: "201.38 864.02 325.26 927.53 440.39 866.78 440.39 815.48 326.33 875.19 201.38 813.52 201.38 864.02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-5",
    "data-name": "Path-64",
    className: "cls-7",
    points: "183.06 761.57 326.08 690.71 468.14 761.57 325.01 833.7 183.06 761.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-Copy-2",
    className: "cls-63",
    points: "235.62 760.75 326.35 715.94 416.46 760.75 325.67 806.36 235.62 760.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-4",
    "data-name": "Path-65",
    className: "cls-15",
    points: "325.01 833.7 325.6 876.52 468.14 802.27 468.14 761.57 325.01 833.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-4",
    "data-name": "Path-66",
    className: "cls-57",
    points: "183.06 761.57 183.06 806.31 325.6 876.52 325.6 833.7 183.06 761.57"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-5",
    "data-name": "Path-65",
    className: "cls-53",
    points: "325.92 965.95 326.81 1030.83 542.78 918.33 542.78 856.66 325.92 965.95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68-3",
    "data-name": "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M509.42,913.81c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-3",
    "data-name": "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M478.74,930.23c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-5",
    "data-name": "Path-66",
    className: "cls-100",
    points: "110.84 856.66 110.84 924.46 326.81 1030.83 326.81 965.95 110.84 856.66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-69",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169,952.71h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326.81,997.96l-42.89-20.93c-2.73-1.33-5.78-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.49.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.72-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-Copy",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326.81,1130.13l-42.89-20.93c-2.73-1.33-5.79-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.73-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-Copy-2",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326.81,1254.13l-42.89-20.93c-2.73-1.33-5.78-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.72-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-Copy-3",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326.81,1380.29l-42.89-20.93c-2.73-1.33-5.78-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.72-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-Copy",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169,1084.88h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-Copy-5-2",
    "data-name": "Path-Copy-5",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M327.58,1463.9c-17.94,0-35.88-4.15-52.33-12.47L12.3,1318.42c-11.01-5.57-15.46-19.1-9.92-30.16,2.09-4.18,5.37-7.54,9.48-9.74l243.2-129.85c32.73-17.48,72.18-18.19,105.51-1.9l268.51,131.2c11.08,5.42,15.72,18.88,10.33,30.02-2.08,4.3-5.41,7.77-9.61,10.01l-247.58,132.24c-17.04,9.1-35.83,13.66-54.63,13.66ZM183.8,1401.81l92.81,46.95c32.81,16.6,71.76,16.16,104.2-1.16l247.58-132.24c3.64-1.95,6.52-4.95,8.33-8.67,4.67-9.65.66-21.32-8.95-26.02l-268.51-131.2c-32.47-15.87-70.89-15.18-102.78,1.85L13.28,1281.17c-3.56,1.9-6.4,4.82-8.21,8.44-4.8,9.59-.95,21.31,8.59,26.14l170.14,86.07Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-2",
    "data-name": "Path-93",
    className: "cls-123",
    points: "235.62 762.2 235.62 348.33 325.6 389.42 325.92 806.36 235.62 762.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-2",
    "data-name": "Path-93-Copy",
    className: "cls-108",
    points: "415.74 762.2 415.74 348.33 326.04 387.85 326.04 806.36 415.74 762.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-4",
    "data-name": "Path-93",
    className: "cls-59",
    points: "262.24 775.75 262.24 488.84 325.09 517.33 325.32 806.36 262.24 775.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-4",
    "data-name": "Path-93-Copy",
    className: "cls-44",
    points: "388.4 775.75 388.4 488.84 325.32 516.24 325.32 806.36 388.4 775.75"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "cls-111",
    d: "M281.16,665.47c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    className: "cls-54",
    d: "M281.16,705.43c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-8",
    className: "cls-111",
    d: "M270.65,739.07c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-2",
    className: "cls-111",
    d: "M325.32,739.07c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-3",
    className: "cls-134",
    d: "M366.32,665.47c2.9,0,5.26,2.35,5.26,5.26s-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26,2.35-5.26,5.26-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-9",
    className: "cls-54",
    d: "M387.35,694.91c2.9,0,5.26,2.35,5.26,5.26s-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26,2.35-5.26,5.26-5.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    className: "cls-54",
    cx: 324.27,
    cy: 689.66,
    r: 7.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-5",
    className: "cls-111",
    d: "M353.71,707.53c1.74,0,3.15,1.41,3.15,3.15s-1.41,3.15-3.15,3.15-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-6",
    className: "cls-111",
    d: "M301.14,718.04c1.74,0,3.15,1.41,3.15,3.15s-1.41,3.15-3.15,3.15-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-7",
    className: "cls-54",
    d: "M323.22,623.42c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-10",
    className: "cls-54",
    d: "M334.78,654.96c1.74,0,3.15,1.41,3.15,3.15s-1.41,3.15-3.15,3.15-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-89-Copy-3-2",
    "data-name": "Path-89-Copy-3",
    className: "cls-95",
    points: "327.42 1413.11 667.45 1580.06 895.42 1466.3 541.73 1300.51 327.42 1413.11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-91",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M877.93,1568.07c-.23,0-.46-.05-.67-.16l-375.01-187c-.74-.37-1.04-1.27-.67-2.01.37-.74,1.27-1.04,2.01-.67l374.33,186.66,293.72-150.06c.74-.38,1.64-.08,2.02.65.38.74.08,1.64-.65,2.02l-294.39,150.41c-.21.11-.45.16-.68.16Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-85-Copy-2",
    "data-name": "Path-85-Copy",
    className: "cls-49",
    d: "M1394.58,1257.88l331.94,170.96,80.11-40.86-312.84-162.97c-4.81,22.19-25.12,37.54-47.78,36.11l-51.44-3.24h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-2",
    "data-name": "Path-77-Copy",
    className: "cls-85",
    d: "M772.53,399.35L1330.4,120.42c7.68-3.84,17.01-.73,20.85,6.95,1.08,2.16,1.64,4.54,1.64,6.95v465.48c0,11.85-6.74,22.68-17.38,27.9l-557.77,273.95c-7.71,3.78-17.02.61-20.8-7.1-1.05-2.13-1.59-4.48-1.59-6.85v-460.54c0-11.78,6.65-22.54,17.18-27.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    className: "cls-55",
    d: "M860.52,445.63l557.87-278.93c7.68-3.84,17.01-.73,20.85,6.95,1.08,2.16,1.64,4.54,1.64,6.95v465.48c0,11.85-6.74,22.68-17.38,27.9l-557.77,273.95c-7.71,3.78-17.02.61-20.8-7.1-1.05-2.13-1.59-4.48-1.59-6.85v-460.54c0-11.78,6.65-22.54,17.18-27.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1016.12,1075.69c-9.29,0-18.62-1.52-27.69-4.57-21.89-7.38-39.6-22.84-49.86-43.53-4.21-8.48-6.98-17.54-8.24-26.92l-4.3-32.06c-8.96-66.77,25.42-132.02,85.55-162.37,6.51-3.28,14.45-.67,17.73,5.84,3.29,6.51.67,14.45-5.84,17.73-50.1,25.29-78.75,79.66-71.28,135.29l4.3,32.06c.87,6.52,2.8,12.81,5.72,18.71,7.13,14.38,19.43,25.12,34.64,30.24,15.21,5.12,31.5,4.02,45.87-3.11,49.74-24.68,78.41-78.27,71.35-133.35l-4.37-34.05c-.87-6.75-2.86-13.26-5.93-19.34-3.28-6.51-.67-14.45,5.84-17.73,6.51-3.28,14.45-.67,17.73,5.84,4.42,8.76,7.29,18.14,8.54,27.87l4.37,34.05c8.49,66.24-25.99,130.68-85.8,160.36-12.12,6.01-25.2,9.05-38.35,9.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-77-Copy-13",
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M859.27,544.52c-26.9,0-51.78-17.6-59.74-44.69-1.92-6.54-2.75-13.3-2.48-20.11l.89-21.66c1.93-46.9,33.42-87.51,78.36-101.06,32.76-9.88,67.44,8.74,77.32,41.49,2.04,6.76,2.9,13.77,2.57,20.83l-1.08,22.98c-2.19,46.5-33.66,86.56-78.32,99.69-5.84,1.72-11.73,2.53-17.53,2.53ZM883.92,382.27c-34.18,10.31-58.13,41.2-59.6,76.87l-.89,21.66c-.16,3.92.32,7.82,1.43,11.58,4.59,15.6,18.91,25.73,34.4,25.73,3.34,0,6.73-.47,10.09-1.46,33.87-9.96,57.74-40.34,59.39-75.6l1.08-22.98c.19-4.05-.31-8.08-1.48-11.97-5.67-18.82-25.6-29.51-44.42-23.84h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M924.68,651.84h0c-1.09,0-1.98-.89-1.97-1.99.08-28.71,12.14-45.51,35.84-49.94,21.71-4.05,35.2-23.6,40.1-58.09.15-1.08,1.15-1.83,2.24-1.68,1.08.15,1.84,1.16,1.68,2.24-5.17,36.36-19.74,57.03-43.3,61.43-21.87,4.08-32.53,19.14-32.61,46.05,0,1.09-.89,1.97-1.98,1.97Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-10",
    className: "cls-113",
    d: "M916.99,709.85l25.8-13.24c1.83-.94,4.08-.22,5.02,1.62.26.51.4,1.08.41,1.66l.57,49.27c.03,2.87-1.59,5.51-4.17,6.78l-26.4,13c-1.73.85-3.81.14-4.66-1.59-.24-.48-.36-1-.36-1.54v-49.77c0-2.61,1.46-5,3.78-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-11",
    className: "cls-69",
    d: "M968.75,653.94l25.77-13.22c1.83-.94,4.08-.22,5.02,1.62.27.52.41,1.09.41,1.67l.61,80.33c.02,2.86-1.6,5.49-4.17,6.75l-26.42,13.01c-1.73.85-3.81.14-4.66-1.59-.24-.48-.36-1-.36-1.54v-80.83c0-2.61,1.46-5,3.78-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-12",
    className: "cls-111",
    d: "M1020.51,585.6l25.76-13.22c1.83-.94,4.08-.22,5.02,1.62.27.52.41,1.1.41,1.68l.64,121.74c.01,2.86-1.6,5.47-4.17,6.73l-26.43,13.01c-1.73.85-3.81.14-4.66-1.59-.24-.48-.36-1-.36-1.54v-122.25c0-2.61,1.46-5,3.78-6.2Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-2",
    className: "cls-112",
    d: "M1149.36,388.26l404.67-208.85c3.81-1.97,8.5-.47,10.47,3.34.57,1.1.87,2.32.87,3.56v102.96c0,5.84-3.28,11.19-8.48,13.85l-404.64,206.32c-3.82,1.95-8.5.43-10.45-3.39-.56-1.09-.85-2.3-.85-3.53v-100.45c0-5.82,3.25-11.15,8.42-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-8",
    className: "cls-6",
    d: "M1123.48,440.04l314.4-162.26h0l1.79,123.7-313.3,159.75c-3.82,1.95-8.5.43-10.45-3.39-.56-1.09-.85-2.3-.85-3.53v-100.45c0-5.82,3.25-11.15,8.41-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-9",
    className: "cls-50",
    d: "M1123.48,647.12l314.4-162.26h0l1.79,123.7-313.3,159.75c-3.82,1.95-8.5.43-10.45-3.39-.56-1.09-.85-2.3-.85-3.53v-100.45c0-5.82,3.25-11.15,8.41-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-3",
    className: "cls-24",
    d: "M1403.16,257.97l150.85-78.5c3.81-1.98,8.5-.5,10.48,3.31.58,1.11.88,2.34.88,3.59v102.91c0,5.84-3.28,11.19-8.48,13.85l-150.58,76.78c-4.1,2.09-9.11.46-11.2-3.64-.6-1.17-.91-2.47-.91-3.78v-99.74c0-6.21,3.46-11.91,8.97-14.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1260.69,383.92c-.72,0-1.41-.39-1.76-1.07-.5-.97-.12-2.17.85-2.67l71.43-37.01c.97-.5,2.17-.12,2.67.85.5.97.12,2.17-.85,2.67l-71.43,37.01c-.29.15-.6.22-.91.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-78-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1260.69,412.39c-.72,0-1.41-.39-1.76-1.07-.5-.97-.12-2.17.85-2.67l33.95-17.59c.97-.5,2.16-.12,2.67.85.5.97.12,2.17-.85,2.67l-33.95,17.59c-.29.15-.6.22-.91.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-4",
    className: "cls-111",
    d: "M1204.17,391.11c11.84-3.15,23.99,3.9,27.14,15.74.56,2.12.81,4.31.73,6.5l-.2,5.48c-.63,17.6-12.75,32.69-29.8,37.1-11.91,3.08-24.07-4.07-27.16-15.98-.53-2.04-.76-4.14-.7-6.24l.15-4.95c.53-17.76,12.66-33.07,29.84-37.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-2",
    "data-name": "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-5",
    className: "cls-96",
    d: "M1201.58,404.88l1.63-.72c2.36-1.04,5.1.04,6.14,2.39.25.57.38,1.18.39,1.79.07,4.24-2.42,8.1-6.3,9.78l-1.51.65c-2.37,1.02-5.12-.07-6.15-2.44-.24-.55-.37-1.14-.38-1.74-.1-4.19,2.34-8.03,6.18-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-6",
    className: "cls-98",
    d: "M1198.83,424.78l13.78-6.48c3.24-1.52,7.1-.13,8.62,3.11.39.83.6,1.73.62,2.64.11,6.09-3.38,11.66-8.91,14.23l-13.59,6.31c-3.25,1.51-7.11.1-8.61-3.15-.37-.81-.58-1.68-.6-2.57-.15-6.01,3.26-11.53,8.69-14.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1423.33,319.72c-.32,0-.65-.08-.95-.24-.96-.52-1.31-1.73-.79-2.69,11.57-21.19,26.15-29.52,43.32-24.76,11.02,3.06,19.94,2.32,26.52-2.18,7.64-5.23,12.29-15.62,13.82-30.86,2.14-21.45,12.25-32.72,30.03-33.5,1.04-.06,2.02.8,2.07,1.89.05,1.09-.8,2.02-1.89,2.07-15.73.69-24.32,10.49-26.27,29.94-1.65,16.46-6.87,27.82-15.52,33.74-7.58,5.19-17.61,6.11-29.81,2.72-15.38-4.27-28.07,3.21-38.79,22.84-.36.66-1.04,1.03-1.74,1.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-79-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1507.22,261.5c-.08,0-.15,0-.23-.01-1.27-.13-2.2-1.26-2.07-2.53,2.16-21.63,12.37-33.01,30.35-33.8,1.28-.05,2.35.93,2.41,2.21.06,1.27-.93,2.35-2.21,2.41-15.54.68-24.03,10.38-25.95,29.64-.12,1.19-1.12,2.08-2.3,2.08Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-2-2",
    "data-name": "Path-77-Copy-2",
    className: "cls-112",
    d: "M1149.36,595.35l404.67-208.85c3.81-1.97,8.5-.47,10.47,3.34.57,1.1.87,2.32.87,3.56v102.96c0,5.84-3.28,11.19-8.48,13.85l-404.64,206.32c-3.82,1.95-8.5.43-10.45-3.39-.56-1.09-.85-2.3-.85-3.53v-100.45c0-5.82,3.25-11.15,8.42-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-3-2",
    "data-name": "Path-77-Copy-3",
    className: "cls-24",
    d: "M1403.16,465.06l150.85-78.5c3.81-1.98,8.5-.5,10.48,3.31.58,1.11.88,2.34.88,3.59v102.91c0,5.84-3.28,11.19-8.48,13.85l-150.58,76.78c-4.1,2.09-9.11.46-11.2-3.64-.6-1.17-.91-2.47-.91-3.78v-99.74c0-6.21,3.46-11.91,8.97-14.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-2",
    "data-name": "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-2",
    "data-name": "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-78-2",
    "data-name": "Path-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1260.69,591c-.72,0-1.41-.39-1.76-1.07-.5-.97-.12-2.17.85-2.67l71.43-37.01c.97-.5,2.17-.12,2.67.85.5.97.12,2.17-.85,2.67l-71.43,37.01c-.29.15-.6.22-.91.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-78-Copy-2",
    "data-name": "Path-78-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1260.69,619.47c-.71,0-1.39-.38-1.75-1.05-.52-.96-.15-2.16.81-2.68l68.14-36.44c.96-.52,2.16-.15,2.68.81.52.96.15,2.16-.81,2.68l-68.14,36.44c-.3.16-.62.23-.93.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-2",
    "data-name": "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-4-2",
    "data-name": "Path-77-Copy-4",
    className: "cls-111",
    d: "M1204.17,598.19c11.84-3.15,23.99,3.9,27.14,15.74.56,2.12.81,4.31.73,6.5l-.2,5.48c-.63,17.6-12.75,32.69-29.8,37.1-11.91,3.08-24.07-4.07-27.16-15.98-.53-2.04-.76-4.14-.7-6.24l.15-4.95c.53-17.76,12.66-33.07,29.84-37.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-3",
    "data-name": "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-5-2",
    "data-name": "Path-77-Copy-5",
    className: "cls-58",
    d: "M1201.58,611.97l1.63-.72c2.36-1.04,5.1.04,6.14,2.39.25.57.38,1.18.39,1.79.07,4.24-2.42,8.1-6.3,9.78l-1.51.65c-2.37,1.02-5.12-.07-6.15-2.44-.24-.55-.37-1.14-.38-1.74-.1-4.19,2.34-8.03,6.18-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-6-2",
    "data-name": "Path-77-Copy-6",
    className: "cls-107",
    d: "M1198.83,631.86l13.78-6.48c3.24-1.52,7.1-.13,8.62,3.11.39.83.6,1.73.61,2.64.11,6.09-3.38,11.66-8.91,14.23l-13.59,6.31c-3.25,1.51-7.11.1-8.61-3.15-.37-.81-.58-1.68-.6-2.57-.15-6.01,3.26-11.53,8.69-14.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-79-2",
    "data-name": "Path-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1423.33,526.81c-.32,0-.65-.08-.95-.24-.96-.52-1.31-1.73-.79-2.69,11.57-21.19,26.15-29.52,43.32-24.76,11.02,3.06,19.94,2.33,26.52-2.18,7.64-5.23,12.29-15.62,13.82-30.86,2.14-21.45,12.25-32.72,30.03-33.5,1.04-.06,2.02.8,2.07,1.89.05,1.09-.8,2.02-1.89,2.07-15.73.69-24.32,10.49-26.27,29.94-1.65,16.46-6.87,27.82-15.52,33.74-7.58,5.19-17.61,6.11-29.81,2.72-15.38-4.26-28.07,3.21-38.79,22.84-.36.66-1.04,1.03-1.74,1.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-79-Copy-2",
    "data-name": "Path-79-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1507.22,468.58c-.08,0-.15,0-.23-.01-1.27-.13-2.2-1.26-2.07-2.53,2.16-21.63,12.37-33,30.35-33.8,1.28-.05,2.35.93,2.41,2.21.06,1.27-.93,2.35-2.21,2.41-15.54.68-24.03,10.38-25.95,29.64-.12,1.19-1.12,2.08-2.3,2.08Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-2-3",
    "data-name": "Path-77-Copy-2",
    className: "cls-112",
    d: "M1149.36,805.63l404.67-208.85c3.81-1.97,8.5-.47,10.47,3.34.57,1.1.87,2.32.87,3.56v102.96c0,5.84-3.28,11.19-8.48,13.85l-404.64,206.32c-3.82,1.95-8.5.43-10.45-3.39-.56-1.09-.85-2.3-.85-3.53v-100.45c0-5.82,3.25-11.15,8.42-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-3-3",
    "data-name": "Path-77-Copy-3",
    className: "cls-24",
    d: "M1403.16,675.33l150.85-78.5c3.81-1.98,8.5-.5,10.48,3.31.58,1.11.88,2.34.88,3.59v102.91c0,5.84-3.28,11.19-8.48,13.85l-150.58,76.78c-4.1,2.09-9.11.46-11.2-3.64-.6-1.17-.91-2.47-.91-3.78v-99.74c0-6.21,3.46-11.91,8.97-14.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-3",
    "data-name": "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-3",
    "data-name": "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-78-3",
    "data-name": "Path-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1260.69,801.28c-.72,0-1.41-.39-1.76-1.07-.5-.97-.12-2.17.85-2.67l71.43-37.01c.97-.5,2.17-.12,2.67.85.5.97.12,2.17-.85,2.67l-71.43,37.01c-.29.15-.6.22-.91.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-78-Copy-3",
    "data-name": "Path-78-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1260.69,829.75c-.71,0-1.39-.38-1.75-1.05-.52-.96-.15-2.16.81-2.68l68.14-36.44c.96-.52,2.16-.15,2.68.81.52.96.15,2.16-.81,2.68l-68.14,36.44c-.3.16-.62.23-.93.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-3",
    "data-name": "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-4-3",
    "data-name": "Path-77-Copy-4",
    className: "cls-111",
    d: "M1204.17,808.47c11.84-3.15,23.99,3.9,27.14,15.74.56,2.12.81,4.31.73,6.5l-.2,5.48c-.63,17.6-12.75,32.69-29.8,37.1-11.91,3.08-24.07-4.07-27.16-15.98-.53-2.04-.76-4.14-.7-6.24l.15-4.95c.53-17.76,12.66-33.07,29.84-37.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-4",
    "data-name": "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-5-3",
    "data-name": "Path-77-Copy-5",
    className: "cls-67",
    d: "M1201.58,822.24l1.63-.72c2.36-1.03,5.1.04,6.14,2.39.25.57.38,1.18.39,1.79.07,4.24-2.42,8.1-6.3,9.78l-1.51.65c-2.37,1.02-5.12-.07-6.15-2.44-.24-.55-.37-1.14-.38-1.74-.1-4.19,2.34-8.03,6.18-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-6-3",
    "data-name": "Path-77-Copy-6",
    className: "cls-90",
    d: "M1198.83,842.14l13.78-6.48c3.24-1.52,7.1-.13,8.62,3.11.39.83.6,1.73.61,2.64.11,6.09-3.38,11.66-8.91,14.23l-13.59,6.31c-3.25,1.51-7.11.1-8.61-3.15-.37-.81-.58-1.68-.6-2.57-.15-6,3.26-11.53,8.69-14.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-79-3",
    "data-name": "Path-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1423.33,737.08c-.32,0-.65-.08-.95-.24-.96-.52-1.31-1.73-.79-2.69,11.57-21.19,26.15-29.52,43.32-24.76,11.02,3.06,19.94,2.32,26.52-2.18,7.64-5.23,12.29-15.62,13.82-30.86,2.14-21.45,12.25-32.72,30.03-33.5,1.04-.06,2.02.8,2.07,1.89.05,1.09-.8,2.02-1.89,2.06-15.73.69-24.32,10.49-26.27,29.94-1.65,16.46-6.87,27.82-15.52,33.74-7.58,5.19-17.61,6.11-29.81,2.72-15.38-4.27-28.07,3.21-38.79,22.84-.36.66-1.04,1.03-1.74,1.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-79-Copy-3",
    "data-name": "Path-79-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1507.22,678.86c-.08,0-.15,0-.23-.01-1.27-.13-2.2-1.26-2.07-2.53,2.16-21.63,12.37-33,30.35-33.8,1.28-.05,2.35.93,2.41,2.21.06,1.27-.93,2.35-2.21,2.41-15.54.68-24.03,10.38-25.95,29.64-.12,1.19-1.12,2.08-2.3,2.08Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-7",
    className: "cls-89",
    d: "M692.14,342.96l74.17-35.71c12.43-5.98,27.36-.76,33.34,11.67,1.63,3.38,2.47,7.08,2.47,10.84v76.79c0,22.58-13.05,43.13-33.48,52.75l-73.89,34.75c-12.48,5.87-27.37.51-33.24-11.97-1.56-3.33-2.38-6.96-2.38-10.63v-75.97c0-22.39,12.83-42.81,33-52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-14",
    className: "cls-32",
    d: "M1075.01,27.68l53.52-25.88c8.94-4.32,19.7-.58,24.02,8.36,1.18,2.44,1.79,5.12,1.79,7.83v55.87c0,16.23-9.36,31.01-24.04,37.95l-53.33,25.19c-8.98,4.24-19.7.4-23.95-8.58-1.13-2.4-1.72-5.03-1.72-7.68v-55.27c0-16.1,9.21-30.77,23.7-37.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-17",
    className: "cls-70",
    d: "M1498.92,39.16l36.86-17.92c6.25-3.04,13.79-.43,16.83,5.82.83,1.72,1.27,3.6,1.27,5.5v38.81c0,11.34-6.53,21.67-16.78,26.54l-36.73,17.44c-6.28,2.98-13.79.31-16.77-5.97-.8-1.69-1.22-3.53-1.22-5.4v-38.4c0-11.25,6.42-21.51,16.54-26.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2-2",
    "data-name": "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    className: "cls-14",
    d: "M1488.52,778.53c31.08,36.16,46.94,57.22,47.55,63.17.89,8.54-9.77,25.7-18.31,39.87-9.39,15.58-19.41,31.55-22.28,32.75-4.18,1.76-8.59-1.7-13.23-10.39l22.04-54.79-35.05-47.77,8-20.88c1.32-3.44,5.17-5.15,8.6-3.84,1.03.4,1.95,1.04,2.67,1.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-29-Copy",
    className: "cls-119",
    d: "M1494.74,1219.38c-12.37-3.15-19.57-1.96-21.59,3.58-3.03,8.31,26.84,28.28,38.69,28.28,7.9,0,10.84-6.73,8.82-20.2l-25.92-11.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-27-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    className: "cls-43",
    d: "M1443.76,943.76c27.79,168.31,44.98,264.42,51.57,288.34,4.41,15.99,26.24,11.79,25.95-3.76.29-43.7-3.25-90.48-10.62-140.34-2.35-15.94-1.69-48.79-2.9-63.71-2.65-32.89-5.23-43.67-7-67.05-.66-8.74-5.01-20.25-13.03-34.52l-43.97,21.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8-Copy-2",
    className: "cls-106",
    d: "M1482.52,1026.55c14.36,32.13,20.38,63.56,18.06,94.31-2.32,30.75,2.77,76.28,15.25,136.59l25.67-10.18-5.92-200.07-53.06-20.65Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    className: "cls-119",
    d: "M1405.73,1251.22c-10.78,1.2-18.62,6.98-15.84,13.87,2.1,5.19,40.84,10.86,46.73,7.93,8.3-2.05,8.68-10.59,1.17-25.63-14.19,1.75-24.87,3.02-32.06,3.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-26",
    className: "cls-62",
    d: "M1405.72,968.32c6.56,161.42,9.84,255.72,9.84,282.91,0,3.45,2.49,8.56,10.16,9.79,7.67,1.24,13.26-3.74,14.15-6.7,8.23-52.14,12.34-96.9,12.34-134.27,0-15.52,4.58-40.8,5.46-59.78.57-12.4,1.03-32.29,1.37-59.68l20.22-22.14c6.12-6.7,8.96-15.77,7.74-24.76l-2.4-17.82h0l-78.88,32.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-106",
    d: "M1424.84,1051.02c13.42,40.06,16.38,69.31,8.88,87.77-7.5,18.45-8.67,63.75-3.5,135.9l37.45-9.73-5.92-200.07-36.91-13.86Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-23",
    className: "cls-65",
    points: "1426.19 762.72 1426.19 796.08 1451.71 784.05 1451.71 762.72 1426.19 762.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23-Copy",
    className: "cls-9",
    d: "M1426.19,762.72v19.71c2.99.96,7.56.78,13.69-.54,6.13-1.32,10.08-3.73,11.84-7.24v-11.93h-25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    className: "cls-25",
    d: "M1410.98,733.04c-1.93,34.46,7.4,47.87,27.97,40.23l-8.22-40.23h-19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    className: "cls-119",
    d: "M1428.69,762.72c-.17-.93,2.68-3.03,2.68-7.79s-4.02-6.68-9.17-3.23c-10.44-5.76-15.28-11.98-14.52-18.66,1.14-10.03,6.96-15.98,17.16-20.26,14.11-5.92,25.97.09,25.97,3.8,15.86,5.04,20.7,13.98,14.53,26.84-1.4,2.92-10.3,24.62-12.49,27.66-2.9,4.03-12.63,6.26-17.25,3.6-3.88-2.23-6.59-10.25-6.91-11.96Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-29",
    className: "cls-60",
    d: "M1401.54,810.78l-7.15,245.43c-.12,4.18,3,7.75,7.17,8.18,40.05,4.14,66.22,4.09,78.5-.15,12.28-4.24,25.19-17.69,38.75-40.34,1.59-2.66,2.09-5.83,1.4-8.84l-28.02-121.91h0l1.57-99.86c.18-11.77-9.21-21.46-20.98-21.65-2.62-.04-5.23.4-7.68,1.3-12.52,4.6-22.33,8.61-29.42,12.04-11.89,5.74-23.26,14.34-34.12,25.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-30-Copy",
    className: "cls-106",
    d: "M1396.21,822.1l-10.03,260.15c31.31,5.27,48.51,5.27,51.59,0,21.51-36.84-7.55-69.94-3.99-155.97,1.45-35.03,2.09-62.67,1.91-82.91-.12-13.8-11.41-24.88-25.2-24.76-2.62.02-5.21.46-7.69,1.29l-6.58,2.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2",
    "data-name": "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1443.13,792.8c8.34-3.89,14.67-9.05,12.81-13.05-1.87-4-8.65-.76-16.98,3.12-8.34,3.89-15.07,6.95-13.21,10.95s9.04,2.86,17.38-1.03Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-25-Copy-2",
    className: "cls-25",
    d: "M1354.84,986.48c-1.12-1.07.69-3.19,5.44-6.36l5.21-6.11,28.78-76.58,2.32-76.23c.23-7.67,6.64-13.7,14.32-13.47.59.02,1.17.07,1.75.16,8.87,1.4,15.28,9.25,14.87,18.23l-3.24,71.79c-.07,1.5-.47,2.97-1.19,4.29l-41.08,76.24h0c-5.06,10.34-7.85,15.72-8.36,16.15-1.1.91-20.4,3.58-18.83,1.67s2.68-3.73,3.63-4.89c2.98-3.65,4.3-6.4,4.3-6.46,0-.31-7.16,2.29-7.93,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25-Copy-3",
    className: "cls-102",
    d: "M1366.63,968.7l25.98-71.26,3.7-76.24c.38-7.81,7.02-13.83,14.82-13.45.51.02,1.02.08,1.52.16,8.96,1.42,15.53,9.17,15.46,18.24l-.57,71.57c-.01,1.63-.42,3.23-1.2,4.66l-41.82,77.59h0l-17.89-11.27Z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-15",
    className: "cls-8",
    d: "M1499.72,626.19c-11.51-3.09-23.36,3.73-26.45,15.25-.46,1.71-.71,3.47-.74,5.24l-.09,5.36c-.27,16.09,10.49,30.28,26.06,34.35,11.59,3.03,23.44-3.9,26.47-15.49.43-1.63.66-3.3.7-4.98l.12-4.89c.38-16.23-10.38-30.63-26.07-34.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-77-Copy-16",
    className: "cls-71",
    d: "M1520.76,617.84c-8.41-2.13-16.95,2.95-19.08,11.36-.29,1.14-.45,2.31-.48,3.49l-.06,2.58c-.27,11.4,7.41,21.46,18.49,24.19,8.46,2.09,17.01-3.07,19.1-11.53.27-1.08.42-2.18.45-3.3l.07-2.25c.35-11.5-7.33-21.7-18.48-24.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1495.72,665.56s-.03,0-.04,0c-.4-.01-.78-.18-1.06-.48l-5.72-6.17c-.56-.61-.53-1.56.08-2.12.61-.56,1.56-.53,2.12.08l4.68,5.05,10.73-10.3c.6-.57,1.55-.55,2.12.04.57.6.55,1.55-.04,2.12l-11.84,11.36c-.28.27-.65.42-1.04.42Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-5-2",
    "data-name": "Group-16-Copy-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-6",
    "data-name": "Path-64",
    className: "cls-117",
    points: "475.67 1408.58 692.38 1301.22 907.61 1408.58 690.75 1517.87 475.67 1408.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-6",
    "data-name": "Path-65",
    className: "cls-94",
    points: "690.75 1517.87 691.64 1582.75 907.61 1470.25 907.61 1408.58 690.75 1517.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-6",
    "data-name": "Path-66",
    className: "cls-51",
    points: "475.67 1408.58 475.67 1476.38 691.64 1582.75 691.64 1517.87 475.67 1408.58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-Copy-2-3",
    "data-name": "Path-69-Copy-2",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M533.83,1504.63h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-Copy-2",
    "data-name": "Path-67-Copy",
    className: "cls-13",
    points: "517.91 1418.91 690.79 1504.25 858.56 1414.51 858.56 1366.62 691.77 1453.95 517.91 1368.07 517.91 1418.91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-2",
    "data-name": "Group-16-Copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-7",
    "data-name": "Path-64",
    className: "cls-115",
    points: "475.67 1283.22 692.38 1175.86 907.61 1283.22 690.75 1392.51 475.67 1283.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-7",
    "data-name": "Path-65",
    className: "cls-80",
    points: "690.75 1392.51 691.64 1457.39 907.61 1344.89 907.61 1283.22 690.75 1392.51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-5",
    "data-name": "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68-4",
    "data-name": "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M874.25,1344.46c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.33,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-4",
    "data-name": "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M843.57,1360.88c-.46,0-.91-.25-1.15-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    "data-name": "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68-5",
    "data-name": "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M874.25,1467.09c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.34,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-5",
    "data-name": "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M843.57,1483.51c-.46,0-.91-.25-1.15-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.33,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-7",
    "data-name": "Path-66",
    className: "cls-128",
    points: "475.67 1283.22 475.67 1351.02 691.64 1457.39 691.64 1392.51 475.67 1283.22"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-2",
    "data-name": "Path-67",
    className: "cls-42",
    points: "517.91 1288.1 690.79 1373.44 858.56 1283.7 858.56 1235.81 691.77 1323.14 517.91 1237.26 517.91 1288.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-8",
    "data-name": "Path-64",
    className: "cls-116",
    points: "475.67 1151.05 692.38 1043.69 907.61 1151.05 690.75 1260.34 475.67 1151.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-8",
    "data-name": "Path-65",
    className: "cls-34",
    points: "690.75 1260.34 691.64 1325.22 907.61 1212.72 907.61 1151.05 690.75 1260.34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2-3",
    "data-name": "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-68-6",
    "data-name": "Path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M874.25,1208.2c-.46,0-.91-.25-1.14-.69-.34-.63-.1-1.42.54-1.75l17.49-9.31c.63-.33,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-17.49,9.31c-.19.1-.4.15-.61.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-68-Copy-6",
    "data-name": "Path-68-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M843.57,1224.62c-.46,0-.91-.25-1.15-.69-.34-.63-.1-1.42.54-1.75l10.03-5.34c.63-.33,1.42-.1,1.75.54.34.63.1,1.42-.54,1.75l-10.03,5.34c-.19.1-.4.15-.61.15Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-8",
    "data-name": "Path-66",
    className: "cls-132",
    points: "475.67 1151.05 475.67 1218.85 691.64 1325.22 691.64 1260.34 475.67 1151.05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-2",
    "data-name": "Path-69",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M533.83,1247.09h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-2",
    "data-name": "Path-70",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M691.65,1292.35l-42.89-20.93c-2.73-1.33-5.79-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-2.39-4.71-6.47-8.21-11.49-9.85-5.02-1.64-10.38-1.23-15.09,1.16l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-Copy-2",
    "data-name": "Path-70-Copy",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M691.65,1424.52l-42.89-20.93c-2.73-1.33-5.78-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.72-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-70-Copy-2-2",
    "data-name": "Path-70-Copy-2",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M691.65,1548.51l-42.89-20.93c-2.73-1.33-5.79-2.04-8.83-2.04-11.1,0-20.12,9.03-20.12,20.12h-1.3c0-11.81,9.61-21.42,21.42-21.42,3.24,0,6.48.75,9.39,2.17l42.31,20.65,39.82-20.19c10.36-5.25,23.07-1.1,28.32,9.27,1.49,2.94,2.28,6.23,2.28,9.53h-1.3c0-3.09-.74-6.18-2.14-8.94-4.93-9.72-16.85-13.63-26.58-8.7l-40.4,20.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-67-Copy-2-2",
    "data-name": "Path-67-Copy-2",
    className: "cls-147",
    points: "566.21 1158.41 690.09 1221.92 805.22 1161.16 805.22 1109.86 691.17 1169.58 566.21 1107.91 566.21 1158.41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-6-2",
    "data-name": "Group-16-Copy-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-9",
    "data-name": "Path-64",
    className: "cls-20",
    points: "547.89 1055.96 690.91 985.1 832.97 1055.96 689.84 1128.09 547.89 1055.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64-Copy",
    className: "cls-78",
    points: "604.66 1057.26 691.17 1014.54 777.09 1057.26 690.52 1100.75 604.66 1057.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65-9",
    "data-name": "Path-65",
    className: "cls-129",
    points: "689.84 1128.09 690.43 1170.91 832.97 1096.66 832.97 1055.96 689.84 1128.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66-9",
    "data-name": "Path-66",
    className: "cls-144",
    points: "547.89 1055.96 547.89 1100.7 690.43 1170.91 690.43 1128.09 547.89 1055.96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-69-Copy-2",
    "data-name": "Path-69-Copy",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M533.83,1379.27h-1.3v-17.28c0-8.89-4.89-16.99-12.75-21.13l-44.42-23.39.6-1.15,44.42,23.39c8.29,4.37,13.44,12.9,13.44,22.27v17.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-Copy-6",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M694.52,1636.33c-17.94,0-35.89-4.15-52.33-12.47l-262.95-133.02c-11.01-5.57-15.46-19.1-9.92-30.16,2.09-4.18,5.37-7.54,9.48-9.74l243.2-129.85c32.73-17.48,72.18-18.19,105.51-1.9l268.51,131.2c11.08,5.42,15.72,18.88,10.33,30.02-2.08,4.3-5.41,7.77-9.61,10.01l-247.58,132.24c-17.04,9.1-35.83,13.66-54.63,13.66ZM550.73,1574.24l92.81,46.95c32.81,16.6,71.76,16.16,104.19-1.16l247.58-132.24c3.64-1.95,6.52-4.94,8.33-8.67,4.67-9.65.66-21.32-8.95-26.02l-268.51-131.2c-32.47-15.87-70.89-15.18-102.78,1.85l-243.2,129.85c-3.56,1.9-6.4,4.82-8.21,8.43-4.8,9.59-.95,21.31,8.59,26.14l170.14,86.07Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-2",
    "data-name": "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-6",
    "data-name": "Path-93",
    className: "cls-88",
    points: "599.73 1056.22 599.73 642.34 689.7 683.43 690.03 1100.38 599.73 1056.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-6",
    "data-name": "Path-93-Copy",
    className: "cls-93",
    points: "779.85 1056.22 779.85 642.34 690.15 681.87 690.15 1100.38 779.85 1056.22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy-2",
    "data-name": "Group-19-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-8",
    "data-name": "Path-93",
    className: "cls-127",
    points: "626.35 1069.76 626.35 782.86 689.2 811.34 689.43 1100.38 626.35 1069.76"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-93-Copy-8",
    "data-name": "Path-93-Copy",
    className: "cls-48",
    points: "752.51 1069.76 752.51 782.86 689.43 810.25 689.43 1100.38 752.51 1069.76"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2",
    "data-name": "Group-17-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-3",
    "data-name": "Oval",
    className: "cls-111",
    d: "M645.27,959.49c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-2",
    "data-name": "Oval-Copy",
    className: "cls-54",
    d: "M645.27,999.44c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-8-2",
    "data-name": "Oval-Copy-8",
    className: "cls-111",
    d: "M634.76,1033.09c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-2-2",
    "data-name": "Oval-Copy-2",
    className: "cls-111",
    d: "M689.43,1033.09c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-3-2",
    "data-name": "Oval-Copy-3",
    className: "cls-134",
    d: "M730.43,959.49c2.9,0,5.26,2.35,5.26,5.26s-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26,2.35-5.26,5.26-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-9-2",
    "data-name": "Oval-Copy-9",
    className: "cls-54",
    d: "M751.46,988.93c2.9,0,5.26,2.35,5.26,5.26s-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26,2.35-5.26,5.26-5.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4-2",
    "data-name": "Oval-Copy-4",
    className: "cls-54",
    cx: 688.38,
    cy: 983.67,
    r: 7.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-5-2",
    "data-name": "Oval-Copy-5",
    className: "cls-111",
    d: "M717.82,1001.54c1.74,0,3.15,1.41,3.15,3.15s-1.41,3.15-3.15,3.15-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6-2",
    "data-name": "Oval-Copy-6",
    className: "cls-111",
    cx: 665.25,
    cy: 1015.21,
    r: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-7-2",
    "data-name": "Oval-Copy-7",
    className: "cls-54",
    d: "M687.33,917.43c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-10-2",
    "data-name": "Oval-Copy-10",
    className: "cls-54",
    d: "M698.89,948.98c1.74,0,3.15,1.41,3.15,3.15s-1.41,3.15-3.15,3.15-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-89-Copy-2-2",
    "data-name": "Path-89-Copy-2",
    className: "cls-35",
    points: "688.05 1583.44 1028.07 1750.38 1256.04 1636.62 902.36 1470.84 688.05 1583.44"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82",
    className: "cls-10",
    points: "1753.98 342.58 1753.98 382.92 1790.93 363.22 1790.93 324.77 1753.98 342.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy",
    className: "cls-72",
    points: "1753.98 342.58 1753.98 382.92 1717.03 363.22 1717.03 324.77 1753.98 342.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81",
    className: "cls-82",
    points: "1716.92 324.77 1753.74 305.92 1790.82 324.77 1753.74 343.27 1716.92 324.77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy",
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-2",
    "data-name": "Path-82",
    className: "cls-27",
    points: "1753.55 341.62 1753.55 409.38 1815.63 376.29 1815.63 311.69 1753.55 341.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy-2",
    "data-name": "Path-82-Copy",
    className: "cls-46",
    points: "1753.55 341.62 1753.55 409.38 1691.48 376.29 1691.48 311.69 1753.55 341.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81-2",
    "data-name": "Path-81",
    className: "cls-114",
    points: "1691.29 311.69 1753.15 280.02 1815.44 311.69 1753.15 342.78 1691.29 311.69"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-2",
    "data-name": "Group-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-3",
    "data-name": "Path-82",
    className: "cls-11",
    points: "1185.24 1356.27 1185.24 1450.13 1271.22 1404.3 1271.22 1314.81 1185.24 1356.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy-3",
    "data-name": "Path-82-Copy",
    className: "cls-124",
    points: "1185.24 1356.27 1185.24 1450.13 1099.26 1404.3 1099.26 1314.81 1185.24 1356.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81-3",
    "data-name": "Path-81",
    className: "cls-86",
    points: "1099 1314.81 1184.68 1270.94 1270.97 1314.81 1184.68 1357.87 1099 1314.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy-2",
    "data-name": "Group-26-Copy",
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-2",
    "data-name": "Group-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-4",
    "data-name": "Path-82",
    className: "cls-31",
    points: "1184.25 1354.03 1184.25 1511.71 1328.7 1434.72 1328.7 1284.39 1184.25 1354.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy-4",
    "data-name": "Path-82-Copy",
    className: "cls-133",
    points: "1184.25 1354.03 1184.25 1511.71 1039.8 1434.72 1039.8 1284.39 1184.25 1354.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81-4",
    "data-name": "Path-81",
    className: "cls-41",
    points: "1039.37 1284.39 1183.31 1210.68 1328.26 1284.39 1183.31 1356.72 1039.37 1284.39"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-3",
    "data-name": "Group-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-5",
    "data-name": "Path-82",
    className: "cls-26",
    points: "1186.12 1206.65 1186.12 1280.59 1253.86 1244.49 1253.86 1173.99 1186.12 1206.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy-5",
    "data-name": "Path-82-Copy",
    className: "cls-87",
    points: "1186.12 1206.65 1186.12 1280.59 1118.38 1244.49 1118.38 1173.99 1186.12 1206.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81-5",
    "data-name": "Path-81",
    className: "cls-30",
    points: "1118.18 1173.99 1185.68 1139.43 1253.66 1173.99 1185.68 1207.91 1118.18 1173.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy-3",
    "data-name": "Group-26-Copy",
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-3",
    "data-name": "Group-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-6",
    "data-name": "Path-82",
    className: "cls-118",
    points: "1185.34 1204.88 1185.34 1329.11 1299.14 1268.45 1299.14 1150.02 1185.34 1204.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82-Copy-6",
    "data-name": "Path-82-Copy",
    className: "cls-146",
    points: "1185.34 1204.88 1185.34 1329.11 1071.54 1268.45 1071.54 1150.02 1185.34 1204.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-81-6",
    "data-name": "Path-81",
    className: "cls-121",
    points: "1071.2 1150.02 1184.6 1091.95 1298.8 1150.02 1184.6 1207.01 1071.2 1150.02"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-94-2",
    "data-name": "Path-94",
    className: "cls-145",
    points: "1703.87 1049.68 1982.48 1180.78 2020.9 1160.95 1792.19 1048.96 1741.58 1039.97 1703.87 1049.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy-3",
    "data-name": "Group-19-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-137",
    d: "M1790.89,575.07c11.66,28.14,21.45,26.99,46.02,45.49,24.57,18.5,20.75,71.31-24.57,77.07-45.33,5.76-74.64-47.35-82.54-86.19-4.16-20.47,0-51.84,20.37-59.2,17.94-6.48,35.2,9.52,40.72,22.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-2",
    "data-name": "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    className: "cls-143",
    d: "M1619.54,643.85c-14.26-8.36-21.39-11.95-21.39-10.79s2.82,4.44,8.46,9.83c.28,4.66,1.39,8.08,3.33,10.26s4.17,4.36,6.69,6.54l2.91-15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-122",
    d: "M1742.29,624.02c-12.66-1.17-22.29,1.78-28.87,8.82-6.58,7.05-15.93,24.95-28.06,53.7l-65.85-43.4-3.65,18.77c43.6,41.36,68.79,62.05,75.57,62.05s17.89-18.75,33.35-56.24l17.52-43.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-6",
    "data-name": "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-9-Copy-2",
    className: "cls-103",
    d: "M1798.91,868.79l5.75,177.03c14.53,17.16,20.17,25.76,16.92,25.81-3.26.05-15.77-5.81-37.54-17.57-9.98-76.09-16.11-122.8-18.38-140.13-2.27-17.33-4.55-34.66-6.82-51.99l40.06,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    className: "cls-119",
    d: "M1812.54,1055.37c8.61,10.8,11.62,16.22,9.04,16.26-3.26.05-15.77-5.19-37.54-15.7l-1.93-15.33c8.46,8.43,14.22,13.36,17.28,14.77,7.77,3.59,12.21-1.18,13.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9-Copy",
    className: "cls-104",
    d: "M1798.91,868.79l1.15,24.18c-6.51,3.41-13.38,5.11-20.61,5.11s-12.71-2.68-16.45-8.04l-4.16-28.09,40.06,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "cls-140",
    d: "M1750.64,857.86l-9.62,183.3c-23.82,6.69-36.82,9.08-39.01,7.17-2.19-1.9,4.53-9.76,20.14-23.58l-10.95-189.32,39.44,22.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10-Copy-2",
    className: "cls-119",
    d: "M1741.58,1030.27l-.57,11.82c-24.57,6.54-37.94,8.85-40.13,6.95-1.71-1.49,2.03-6.64,11.24-15.43,1-.95,2.01,8.14,8.35,7.71,2.97-.21,10.01-3.89,21.11-11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10-Copy",
    className: "cls-104",
    d: "M1750.64,857.86l-1.65,31.38c-7.15,1.4-13.64,1.4-19.46,0-5.82-1.4-11.15-5.7-15.97-12.9l-2.37-40.9,39.44,22.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-2",
    "data-name": "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8-Copy",
    className: "cls-12",
    d: "M1801.75,771.41l9.26,107.19c-16.84,1.1-33.31,2.18-49.43,3.25-35.41,2.35-48.86-23.41-58.76-37.67l9.85-91.39,89.08,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8-Copy-7",
    className: "cls-142",
    d: "M1801.75,771.41l8.35,96.66.91,10.53c-16.84,1.1-33.31,2.18-49.43,3.25-35.41,2.35-48.86-23.41-58.76-37.67.52-4.86.92-8.51,1.18-10.94,1.93-17.88,4.82-44.69,8.67-80.44l89.08,18.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6-Copy",
    className: "cls-92",
    d: "M1793.46,687.17l-6.02,31.14,19.09,53.23c-45.21,12.76-77.72,6.32-97.52-19.34,12.07-25.88,15.75-47.56,11.05-65.04-7.06-26.22,2.69-41.18,22.24-63.14l29.78,5.56,21.39,57.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-141",
    d: "M1793.72,736.55c-32.02,0-53.81-2.44-65.37-7.31,9.3,19.45,33.76,29.18,73.4,29.18l-8.02-21.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-136",
    d: "M1772.07,629.58c18.68,5.87,31.14,13.31,37.38,22.33,9.36,13.53,47.6,76.65,36.9,83.56-7.14,4.61-35.51,10.65-85.11,18.12l-10.11-18.74,58.33-21.32-24.65-40.4-12.73-43.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-74",
    className: "cls-143",
    d: "M1759.96,751.33l-27.75-2.08c-11.29-1.15-19.25-6.81-23.9-16.98l21.99,4.6,20.82-4.6,8.84,19.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-79",
    d: "M1749,606.51v18.46c-2.3,31.29-2.3,46.94,0,46.94s9.06-14.05,20.27-42.15v-27.22l-20.27,3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy-2",
    className: "cls-111",
    d: "M1747.91,641.63c-1.81,20.11-1.44,30.2,1.09,30.28,2.54.08,7.1-8.53,13.68-25.84l-14.78-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy",
    className: "cls-104",
    d: "M1749,606.51v12.59c4.44,2.7,8.32,3.4,11.63,2.09,3.31-1.31,6.19-3.83,8.64-7.55v-11.09l-20.27,3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-47",
    d: "M1745.96,568.31c6.89,13.68,17.39,20.15,31.51,19.42-3.44,16.93-10.61,25.24-21.52,24.93-10.9-.31-16.72-11.1-17.46-32.38l7.47-11.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1754.44,603.51c-1.69,0-2.88-.98-3.67-2.03-.15-.19-.11-.47.08-.62.2-.15.47-.11.62.09,1.5,1.98,3.42,2.21,5.88.69.21-.13.48-.07.61.14.13.21.06.48-.14.61-1.29.8-2.41,1.12-3.37,1.12Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-50",
    className: "cls-110",
    d: "M1731.4,740.02l53.41-13.3c1.56-.39,2.51-1.97,2.12-3.52-.2-.8-.73-1.48-1.46-1.87l-67.76-35.86c-2.47-1.31-5.32-1.68-8.04-1.06l-61.04,14h0l82.76,41.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-2",
    "data-name": "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-48",
    className: "cls-45",
    d: "M1705.76,668.85l-81.12-42.2c-1.42-.74-3.18-.19-3.92,1.24-.35.68-.42,1.47-.2,2.2l20.08,64.68c.71,2.27,2.31,4.16,4.43,5.22l81.01,40.42c1.44.72,3.18.13,3.9-1.3.34-.68.4-1.46.17-2.18l-20.07-62.98c-.7-2.2-2.24-4.02-4.28-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-48-Copy",
    className: "cls-74",
    d: "M1671.91,677.2l-.84-.45c-1.72-.92-3.86-.27-4.78,1.45-.4.74-.52,1.6-.33,2.43,1.04,4.74,4.17,8.75,8.52,10.91l.62.31c1.74.86,3.85.15,4.71-1.58.36-.73.46-1.55.28-2.34-1.04-4.59-4.02-8.5-8.17-10.71Z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutContent);
export default __webpack_public_path__ + "static/media/about-content.e7d8c81cc92981563e17cc57045f35e5.svg";
export { ForwardRef as ReactComponent };